import NewsletterForm from "@/components/feature/NewsletterForm";

const points = [
  { icon: "ri-time-line", text: "每天早上 08:00 准时送达当日精选清单" },
  { icon: "ri-filter-3-line", text: "人工筛掉标题党与重复内容，只留值得看的" },
  { icon: "ri-mail-close-line", text: "随时一键退订，不分享你的邮箱" },
];

export default function SubscribeBand() {
  return (
    <section className="bg-primary-950">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-6">
            <p className="text-xs tracking-[0.18em] text-accent-400 mb-3">看点日报</p>
            <h2 className="font-heading text-2xl md:text-3xl leading-snug text-background-50">
              不想自己翻热搜？把每日精选交给我们
            </h2>
            <ul className="mt-7 space-y-3.5">
              {points.map((point) => (
                <li key={point.text} className="flex items-center gap-3 text-sm text-background-100/90">
                  <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-900 text-accent-300 shrink-0">
                    <i className={`${point.icon} text-base`}></i>
                  </span>
                  {point.text}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-6">
            <div className="rounded-lg bg-primary-900/70 border border-primary-800 p-6 md:p-8">
              <h3 className="text-base font-medium text-background-50 mb-1">订阅每日看点</h3>
              <p className="text-xs text-background-200/75 mb-5">输入邮箱即可订阅，第一封明天早上送达。</p>
              <NewsletterForm tone="dark" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}